var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"value":_vm.initValue,"dense":"","items":_vm.items,"label":_vm.label,"disabled":_vm.disabled,"outlined":"","clearable":""},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }